import React, { createContext, useContext, useMemo, useState } from 'react';
import {
  DevelopmentModeToggleContent,
  IDevelopmentModeToggleProvider,
} from './interfaces';

export const DevelopmentModeToggleContext =
  createContext<DevelopmentModeToggleContent>({
    inDevMode: false,
    setInDevMode: (): void => {},
  });

export const DevelopmentModeToggleProvider: React.FC<
  IDevelopmentModeToggleProvider
> = ({ children }) => {
  const [inDevMode, setInDevMode] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      inDevMode,
      setInDevMode,
    }),
    [inDevMode]
  );

  return (
    <DevelopmentModeToggleContext.Provider value={value}>
      {children}
    </DevelopmentModeToggleContext.Provider>
  );
};

export const useDevelopmentModeToggle = () =>
  useContext(DevelopmentModeToggleContext);
